<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                How to rent guide
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <form @submit.prevent="submit">
                <p>
                    As a tenant you need to confirm that you have received the <strong>How to rent</strong> guide.
                </p>

                <p>
                    You can <a
                        href="https://www.gov.uk/government/publications/how-to-rent"
                        target="_blank"
                    >view the guide</a> on the gov.uk website.
                </p>

                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <b-button
                    type="is-success"
                    tag="button"
                    :disabled="isSending || isSuccess"
                    native-type="submit"
                >
                    I've received/viewed the guide
                </b-button>
            </form>
        </section>
    </div>
</template>

<script>
import Form from '../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return this.parseClientErrors();
                }

                this.isSending = true;

                this.$store.dispatch('user/confirmHowToRentGuide')
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;

                    // set meta value as "true" to stop modal from appearing again
                    this.$meta.readHowToRentGuide = true;
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
